import { isNotNil } from 'utils';

import { formatDateToLocale } from './formatDateToLocale';

export const descriptionNumberAndDate = (number?: number | string | null, date?: Date | null) =>
    `${isNotNil(number) ? ` №${number}` : ''}${date ? ` от ${formatDateToLocale(date)}` : ''}`;
export const workOrderChangeDescriptionNumberAndDate = (
    number?: string | null,
    date?: Date,
    workOrderId?: string | null,
) =>
    `${number ? ` №${number}` : ''} к НЗ ${
        workOrderId ? `№${workOrderId.replace(/(^|[^Изм])Изм\.\s.*$/g, '$1')}` : ''
    }${date ? ` от ${formatDateToLocale(date)}` : ''}`;
